export const EXCLUDED_SLOTS = ['L17', 'L18'];
export const MORNING_LAB_SLOTS = Array.from({ length: 30 }, (_, i) => `L${i + 1}`)
  .filter(slot => !EXCLUDED_SLOTS.includes(slot)); // L1-L30 except L17, L18
export const EVENING_LAB_SLOTS = Array.from({ length: 30 }, (_, i) => `L${i + 31}`); // L31-L60

export const morningTheorySlotsConst = ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'TA1', 'TB1', 'TC1', 'TD1', 'TE1', 'TF1', 'TG1', 'TAA1', 'TCC1'];
export const eveningTheorySlotsConst = ['A2', 'B2', 'C2', 'D2', 'E2', 'F2', 'G2', 'TA2', 'TB2', 'TC2', 'TD2', 'TE2', 'TF2', 'TG2', 'TAA2', 'TBB2', 'TCC2', 'TDD2'];

export const dayRows = [
  {
    day: 'MON',
    slots: ['A1/L1', 'F1/L2', 'D1/L3', 'TB1/L4', 'TG1/L5', 'L6', 'A2/L31', 'F2/L32', 'D2/L33', 'TB2/L34', 'TG2/L35', 'L36']
  },
  {
    day: 'TUE',
    slots: ['B1/L7', 'G1/L8', 'E1/L9', 'TC1/L10', 'TAA1/L11', 'L12', 'B2/L37', 'G2/L38', 'E2/L39', 'TC2/L40', 'TAA2/L41', 'L42']
  },
  {
    day: 'WED',
    slots: ['C1/L13', 'A1/L14', 'F1/L15', 'L16', { colspan: 2, content: 'Extramural Hours' }, 'C2/L43', 'A2/L44', 'F2/L45', 'TD2/L46', 'TBB2/L47', 'L48']
  },
  {
    day: 'THU',
    slots: ['D1/L19', 'B1/L20', 'G1/L21', 'TE1/L22', 'TCC1/L23', 'L24', 'D2/L49', 'B2/L50', 'G2/L51', 'TE2/L52', 'TCC2/L53', 'L54']
  },
  {
    day: 'FRI',
    slots: ['E1/L25', 'C1/L26', 'TA1/L27', 'TF1/L28', 'TD1/L29', 'L30', 'E2/L55', 'C2/L56', 'TA2/L57', 'TF2/L58', 'TDD2/L59', 'L60']
  }
];

export const theoryTimes = [
  "08:00AM\nto\n08:50AM",
  "09:00AM\nto\n09:50AM",
  "10:00AM\nto\n10:50AM",
  "11:00AM\nto\n11:50AM",
  "12:00PM\nto\n12:50PM",
  "",
  "02:00PM\nto\n02:50PM",
  "03:00PM\nto\n03:50PM",
  "04:00PM\nto\n04:50PM",
  "05:00PM\nto\n05:50PM",
  "06:00PM\nto\n06:50PM",
  ""
];

export const labTimes = [
  "08:00AM\nto\n08:50AM",
  "08:51AM\nto\n09:40AM",
  "09:51AM\nto\n10:40AM",
  "10:41AM\nto\n11:30AM",
  "11:40AM\nto\n12:30PM",
  "12:31PM\nto\n01:20PM",
  "02:00PM\nto\n02:50PM",
  "02:51PM\nto\n03:40PM",
  "03:51PM\nto\n04:40PM",
  "04:41PM\nto\n05:30PM",
  "05:40PM\nto\n06:30PM",
  "06:31PM\nto\n07:20PM"
]; 